<template>
    <div class="avatar" v-bind:style="contents" v-bind:class="{['size-'+size]: size}">
        <slot name="tooltip-content"></slot>
        <div class="flex-content text-center">
            <div class="avatar-inner">
                <!-- @slot Text in Avatar, mainly initials -->
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Avatar',
        components: {},
        props: {
            contents: {
                type: Object
            },
            size: {
                type: String,
                default: 'md',
                description: 'Could be sm, md, lg, '
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./Avatar.scss" scoped lang="scss"></style>

